export default __webpack_public_path__ + "06222bdb73b05ff4fd424d36cb650f58.jpg";